<template>
  <div>
    <v-row class="grey darken-4 mx-0">
      <v-col cols="6" md="3" lg="2">
        <c-select
          rotulo="Opções de busca"
          itemText="label"
          itemValue="value"
          :clearable="false"
          :lista="options"
          :item.sync="searchFields.option"
        />
      </v-col>
      <v-col cols="6" md="3" lg="3">
        <v-text-field
          class="text-caption"
          label="Termo da busca"
          :placeholder="searchFields.option.label"
          :maxlength="searchFields.option.maxLength"
          outlined
          dense
          dark
          v-model="searchFields.text"
        />
      </v-col>
    </v-row>
    <c-index-buttons @search="sendSearch()" @register="openRegister()" @changeHeader="changeHeaderDialog = !changeHeaderDialog" />
    <v-row>
      <v-col cols="12">
        <megabit-table
          :table-header="tableHeaderSelected"
          :table-items="cityList"
          :loading="loadingItems"
          selectable
          :doDelete="doDelete"
          @item-selected="selectItem($event)"
          route="cidade.register"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-inline-flex">
        <v-pagination
          class="ml-auto"
          v-model="query.page"
          :total-visible="pagination.per_page"
          :length="pagination.last_page"
          :disabled="loadingItems"
          @input="sendSearch()"
        />
      </v-col>
    </v-row>

    <router-view />
    <change-header 
      v-model="tableHeaderAvaiable" 
      :showDialog="changeHeaderDialog" 
      @close="changeHeaderDialog = !changeHeaderDialog" 
      :name="headerName"
      />
  </div>
</template>

<script>
import MegabitTable from '@/components/shared/table/MegabitTable'
import cSelect from '@/components/shared/base-input/BaseSelect'
import cIndexButtons from '@/components/shared/base-buttons/IndexButtons'
import { tableMixin } from '@/mixins/component/table/TableMixin'
import { headerMixin } from "@/mixins/component/table/HeaderMixin"
import { mapActions, mapState } from 'vuex'
export default {
  components: { MegabitTable, cSelect, cIndexButtons },
  mixins: [tableMixin, headerMixin],
  data: () => ({
    headerName: 'cityIndex',
    options: [
      { label: 'Código', value: 'codigo', maxLength: 10 },
      { label: 'Descricao', value: 'descricao', maxLength: 40 },
      { label: 'UF', value: 'uf', maxLength: 2 },
      { label: 'Cód. Municipio', value: 'codigoMunicipio', maxLength: 10 },
    ],
    searchFields: {
      option: {},
    },
    query: {
      codigo: 0,
      descricao: '',
      uf: '',
      codigoMunicipio: '',
      page: 1,
      todos: null,
    },
    tableHeaderAvaiable: [
        { text: 'Código', value: 'CODIGO', width: 100, align: 'start' , show: true},
        { text: 'Descrição', value: 'DESCRICAO', align: 'start' , show: true},
        { text: 'UF', value: 'UF', width: 80 , show: true},
        { text: 'Código Municipio', value: 'CODIGOMUNICIPIO', width: 150 , show: true},
        { text: 'Ações', value: 'controls', align: 'right' , show: true},
      ]
  }),
  computed: {
    ...mapState('cityModule', ['loadingItems', 'pagination', 'cityList']),
  },
  async created() {
    try {
      await this.getCities(this.query)
      this.searchFields.option = this.options[0]
    } catch (error) {
      this.$toasted.error(error, {duration: null});
    }
    this.mountHeader();
  },
  methods: {
    ...mapActions('cityModule', ['getCities', 'deleteCity']),
    async doDelete(item) {
      try {
        const response = await this.deleteCity(item.CODIGO)
        this.$toasted.success(response);
      } catch (error) {
        this.$toasted.error(error, {duration: null});
      }
    },

    openRegister() {
      this.$router.push({ name: 'cidade.register' })
    },

    async sendSearch() {
      try {
        let searchText = this.searchFields.text ?? ''
        let key = this.searchFields.option.value

        if (searchText.trim().length > 0 && key) {
          this.query[key] = searchText
        }

        await this.getCities(this.query)
        this.cleanSearch()
      } catch (error) {
        this.$toasted.error(error, {duration: null});
      }
    },
    cleanSearch() {
      Object.keys(this.query).forEach((key) => {
        if (key !== 'page' && key !== 'todos') this.query[key] = ''
      })
    },
  },
}
</script>

<style></style>
